import { FormGroup } from '@angular/forms';
import { GroupMarketingPreferenceForm } from './group-marketing-preference-form.interface';

export type GroupMarketingPreferenceFormValue = ReturnType<
  FormGroup<GroupMarketingPreferenceForm>['getRawValue']
>;
